export const detectTypeOfString = (texto: string) => {
  // Expresiones Regulares
  // 1. camelCase: Empieza con minúscula, no tiene guiones bajos, pero contiene mayúsculas en el medio.
  const regexCamelCase = /^[a-z]+(?:[A-Z][a-z0-9]*)*$/;

  // 2. snake_case: Contiene al menos un guion bajo y solo usa minúsculas y números.
  const regexSnakeCase = /^[a-z0-9]+(?:_[a-z0-9]+)*$/;

  let resultado = "";

  switch (true) {
    // Caso 1: Detecta camelCase
    case regexCamelCase.test(texto):
      resultado = texto;
      break;

    // Caso 2: Detecta snake_case
    case regexSnakeCase.test(texto):
      resultado = texto
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase());
      break;

    // Caso por defecto: No coincide con ninguno de los estilos principales
    default:
      // TODO: Capitalize the first letter and replace underscores with spaces
      resultado =
        texto.charAt(0).toUpperCase() + texto.slice(1).replace(/_/g, " ");
      break;
  }

  return resultado;
};
